import React, { useState } from "react";

import { useFormikContext } from "formik";
import { motion, AnimatePresence } from "framer-motion";

import { Typography } from "clearsense-ui/components";
import { Input, Select } from "clearsense-ui/components/formik";
import ContentBox from "components/Common/ContentBox";

import Footer from "./Footer";

import { DEFAULT_LIMITS, VARIANTS } from "../constants";

const ConditionGroup = ({ arrayHelpers, index, conditions, columnNames }) => {
  const [conditionValues, setConditionValues] = useState([]);
  const [limits, setLimits] = useState(DEFAULT_LIMITS);

  const {
    setFieldValue,
    values: { conditionGroups },
  } = useFormikContext();

  const getColumnNames = () => {
    const selectedColumns = conditionGroups.map(
      ({ columnName: { value } }) => value
    );
    const deselectedColumns = columnNames.filter(
      column => !selectedColumns.includes(column)
    );
    return deselectedColumns.map(column => ({ value: column, label: column }));
  };

  const handleColumnChange = selectedColumn => {
    setFieldValue(`conditionGroups.${index}.columnValue`, "");
    setFieldValue(`conditionGroups.${index}.columnName`, selectedColumn);
    const selectedColumnValues = conditions[selectedColumn.value].columnValues;
    setConditionValues(selectedColumnValues);
  };

  const handleColumnValueChange = selectedColumnValue => {
    setFieldValue(`conditionGroups.${index}.columnValue`, selectedColumnValue);
    const min = -selectedColumnValue.value.limit;
    setLimits({ min, max: 100 + min, isDisabled: false });
  };

  return (
    <AnimatePresence>
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={VARIANTS}
      >
        <ContentBox className="rounded p-4 space-y-4 w-full">
          <Typography className="text-gray-500">
            Add a condition to your What-If analysis.
          </Typography>
          <Select
            label="Column Name"
            name={`conditionGroups.${index}.columnName`}
            placeholder="Select a column name"
            required
            options={getColumnNames()}
            onChange={handleColumnChange}
          />
          <Select
            label="Value"
            name={`conditionGroups.${index}.columnValue`}
            placeholder={
              conditionValues?.length === 0
                ? "Please select a column name to select value"
                : "Select a value"
            }
            required
            isDisabled={conditionValues?.length === 0}
            options={conditionValues}
            onChange={handleColumnValueChange}
          />
          <Input
            label="Percent Change"
            name={`conditionGroups.${index}.change`}
            placeholder={
              limits.isDisabled
                ? "Please select a column value to enter change"
                : "Enter change in %"
            }
            type="number"
            required
            min={limits.min}
            max={limits.max}
            disabled={limits.isDisabled}
          />
          <Footer
            arrayHelpers={arrayHelpers}
            setConditionValues={setConditionValues}
            limits={limits}
            setLimits={setLimits}
            index={index}
          />
        </ContentBox>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConditionGroup;
